<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container"  [loading]="loading()">
	@if(!isSharing()){
		<lgb-back name="collect-binders" [fragment]="uBinder()?.ident"></lgb-back>
	}
	<div class="my-4">
		<lgb-message [(error)]="error"></lgb-message>
	</div>
	<lgb-litle-binder
		[admin]="!isSharing()"
		(isLoading)="loading.set($event)"
		(error)="error.set($event)"
		[uBinder]="uBinder()"
		[binder]="binder()"
	></lgb-litle-binder>
	<div>
		<div class="tabs tabs-box my-4">
			<a (click)="tabActive.set('overview')" [ngClass]="{'tab-active': tabActive()=='overview'}" class="tab">Aperçu</a>
			<a (click)="tabActive.set('pages')" [ngClass]="{'tab-active': tabActive()=='pages'}" class="tab">Pages</a>
			<a (click)="tabActive.set('cards')" [ngClass]="{'tab-active': tabActive()=='cards'}" class="tab">Cartes</a>
		</div>
		<div [ngStyle]="{display: ((tabActive()=='overview')? 'block' : 'none')}">
			<lgb-binder-overview 
				[admin]="!isSharing()"
				[uBinder]="uBinder()"
				[binder]="binder()"
				[cards]="cards()"
				[references]="references()"
			></lgb-binder-overview>
		</div>
		<div [ngStyle]="{display: ((tabActive()=='pages')? 'block' : 'none')}">
			<lgb-binder-page-list 
				[admin]="!isSharing()"
				[uBinder]="uBinder()"
				[pages]="pages()"
				[scans]="scans()"
			></lgb-binder-page-list>
		</div>
		<div [ngStyle]="{display: ((tabActive()=='cards')? 'block' : 'none')}">
			<lgb-binder-card-list
				[share]="share()"
				[uBinder]="uBinder()"
				[cards]="cards()"
				[scans]="scans()"
				[references]="references()"
				[pages]="pages()"
			></lgb-binder-card-list>
		</div>
	</div>
</div>
